// The re-entry screen's analytics events: one builder per event, so names
// and properties are defined, and tested, in one place. Properties are
// small bounded scalars only: never an id, an email, a phone or a message.
// The quote flow's analytics scope adds the quote and credential to each.

import type { AnalyticsProperties } from "analytics/AnalyticsContext";
import type { GrantMethod } from "pages/Login/login-grant-flow";
import type { ConfirmTrigger } from "pages/StartLead/events";

import type {
  ReentryFailureReason,
  ReentryMode,
  ReentryViewEntry,
} from "./reentry";

export type ReentryEvent = { name: string; properties: AnalyticsProperties };

function event(
  name: string,
  properties: AnalyticsProperties = {},
): ReentryEvent {
  return { name, properties };
}

export const reentryEvents = {
  viewed: (view: {
    mode: ReentryMode;
    reason: string;
    entry: ReentryViewEntry;
  }): ReentryEvent =>
    event("quote_flow_reentry_viewed", {
      mode: view.mode,
      reason: view.reason,
      entry: view.entry,
    }),

  sent: (send: {
    method: GrantMethod;
    mode: ReentryMode;
    trigger: ConfirmTrigger;
  }): ReentryEvent =>
    event("quote_flow_reentry_sent", {
      method: send.method,
      mode: send.mode,
      trigger: send.trigger,
    }),

  accepted: (proof: { method: GrantMethod }): ReentryEvent =>
    event("quote_flow_reentry_accepted", proof),

  failed: (failure: { reason: ReentryFailureReason }): ReentryEvent =>
    event("quote_flow_reentry_failed", failure),

  notFound: (): ReentryEvent => event("quote_flow_reentry_not_found"),
};
